import { SignalRTypes } from '../actions';

const initState = {
	connected: false,
	connecting: true,
	connectSlow: false,
	producerDown: false,
	jackpotRetryConnect: false,
	staticConnected: false,
	staticConnecting: false,
	staticRetryConnect: false,
	staticDisconnectRequested: false,
	virtualConnected: false,
	virtualConnecting: false,
	virtualRetryConnect: false,
	virtualDisconnectRequested: false,
	liveConnected: false,
	liveConnecting: false,
	liveRetryConnect: false,
	liveDisconnectRequested: false,
	luckyNumbersConnected: false,
	luckyNumbersConnecting: false,
	luckyNumbersRetryConnect: false,
	luckyNumbersDisconnectRequested: false,
	spinAndWinConnected: false,
	spinAndWinConnecting: false,
	spinAndWinRetryConnect: false,
	spinAndWinDisconnectRequested: false,
	booongoConnected: false,
	booongoConnecting: false,
	booongoRetryConnect: false,
	booongoDisconnectRequested: false,
};

const signalr = (state = initState, action) => {

	switch (action.type) {

		case SignalRTypes.Connect_Request:
			return {
				...state,
				connected: false,
				connecting: true,
			}

		case SignalRTypes.Connect_Success:
			return {
				...state,
				connected: true,
				connecting: false,

			}

		case SignalRTypes.Connect_Error:
			return {
				...state,
				connected: false,
				connecting: false,

			}

		case SignalRTypes.Connect_Slow:
			return {
				...state,
				connected: true,
				connecting: false,
				connectSlow: true,
			}
		case SignalRTypes.Disconnect_Success:
			return {
				...state,
				connected: false,
			}

		case SignalRTypes.Producer_Down:
			return {
				...state,
				producerDown: true,
			}
		case SignalRTypes.Producer_Up:
			return {
				...state,
				producerDown: false,
			}
		case SignalRTypes.Connect_to_Banner_Hub_Success:
			return {
				...state,
				kioskBannersConnection: action.kioskBannersConnection,
			}
		case SignalRTypes.Get_Current_Banner_Request:
			return {
				...state,
				loadingCurrentKioskBanner: true,
			}
		case SignalRTypes.Get_Current_Banner_Success:
			return {
				...state,
				loadingCurrentKioskBanner: false,
				currentKioskBanner: action.currentKioskBanner,
			}
		case SignalRTypes.On_Banner_Change_Success:
			return {
				...state,
				currentKioskBanner: action.currentKioskBanner,
			}
		case SignalRTypes.Jackpot_Connect_Retry:
			return {
				...state,
				jackpotRetryConnect: true,
			}

		case SignalRTypes.Jackpot_Connect_Success:
		case SignalRTypes.Jackpot_Disconnect_Success:
		case SignalRTypes.Jackpot_Connect_Error:
			return {
				...state,
				jackpotRetryConnect: false,
			}
		case SignalRTypes.Static_Connect_Request:
			return {
				...state,
				staticConnected: false,
				staticConnecting: true,
				staticDisconnectRequested: false,
			}

		case SignalRTypes.Static_Connect_Success:
			return {
				...state,
				staticConnected: true,
				staticConnecting: false,
				staticRetryConnect: false,
				staticDisconnectRequested: false,

			}
		case SignalRTypes.Static_Disconnect_Success:
		case SignalRTypes.Static_Connect_Error:
			return {
				...state,
				staticConnected: false,
				staticConnecting: false,
				staticRetryConnect: false,
				staticDisconnectRequested: false,
			}
		case SignalRTypes.Static_Disconnect_Request:
			return {
				...state,
				staticDisconnectRequested: true,
			}
		case SignalRTypes.Static_Connect_Retry:
			return {
				...state,
				staticConnected: false,
				staticConnecting: true,
				staticRetryConnect: true,
			}

		case SignalRTypes.Virtual_Connect_Request:
			return {
				...state,
				virtualConnected: false,
				virtualConnecting: true,
				virtualDisconnectRequested: false,
			}
		case SignalRTypes.Virtual_Connect_Success:
			return {
				...state,
				virtualConnected: true,
				virtualConnecting: false,
				virtualRetryConnect: false,
				virtualDisconnectRequested: false,

			}
		case SignalRTypes.Virtual_Disconnect_Success:
		case SignalRTypes.Virtual_Connect_Error:
			return {
				...state,
				virtualConnected: false,
				virtualConnecting: false,
				virtualRetryConnect: false,
				virtualDisconnectRequested: false,
			}
		case SignalRTypes.Virtual_Disconnect_Request:
			return {
				...state,
				virtualDisconnectRequested: true,
			}
		case SignalRTypes.Virtual_Connect_Retry:
			return {
				...state,
				virtualConnected: false,
				virtualConnecting: true,
				virtualRetryConnect: true,
			}

		case SignalRTypes.Live_Connect_Request:
			return {
				...state,
				liveConnected: false,
				liveConnecting: true,
				liveDisconnectRequested: false,
			}
		case SignalRTypes.Live_Connect_Success:
			return {
				...state,
				liveConnected: true,
				liveConnecting: false,
				liveRetryConnect: false,
				liveDisconnectRequested: false,
			}
		case SignalRTypes.Live_Disconnect_Success:
		case SignalRTypes.Live_Connect_Error:
			return {
				...state,
				liveConnected: false,
				liveConnecting: false,
				liveRetryConnect: false,
				liveDisconnectRequested: false,
			}
		case SignalRTypes.Live_Disconnect_Request:
			return {
				...state,
				liveDisconnectRequested: true,
			}
		case SignalRTypes.Live_Connect_Retry:
			return {
				...state,
				liveConnected: false,
				liveConnecting: true,
				liveRetryConnect: true,
			}

		case SignalRTypes.SpinAndWin_Connect_Request:
			return {
				...state,
				spinAndWinConnected: false,
				spinAndWinConnecting: true,
				spinAndWinDisconnectRequested: false,
			}
		case SignalRTypes.SpinAndWin_Connect_Success:
			return {
				...state,
				spinAndWinConnected: true,
				spinAndWinConnecting: false,
				spinAndWinRetryConnect: false,
				spinAndWinDisconnectRequested: false,
			}
		case SignalRTypes.SpinAndWin_Disconnect_Success:
		case SignalRTypes.SpinAndWin_Connect_Error:
			return {
				...state,
				spinAndWinConnected: false,
				spinAndWinConnecting: false,
				spinAndWinRetryConnect: false,
				spinAndWinDisconnectRequested: false,
			}
		case SignalRTypes.SpinAndWin_Disconnect_Request:
			return {
				...state,
				spinAndWinDisconnectRequested: true,
			}
		case SignalRTypes.SpinAndWin_Connect_Retry:
			return {
				...state,
				liveConnected: false,
				liveConnecting: true,
				liveRetryConnect: true,
			}

		case SignalRTypes.LuckyNumbers_Connect_Request:
			return {
				...state,
				luckyNumbersConnected: false,
				luckyNumbersConnecting: true,
				luckyNumbersDisconnectRequested: false,
			}
		case SignalRTypes.LuckyNumbers_Connect_Success:
			return {
				...state,
				luckyNumbersConnected: true,
				luckyNumbersConnecting: false,
				luckyNumbersRetryConnect: false,
				luckyNumbersDisconnectRequested: false,
			}
		case SignalRTypes.LuckyNumbers_Disconnect_Success:
		case SignalRTypes.LuckyNumbers_Connect_Error:
			return {
				...state,
				luckyNumbersConnected: false,
				luckyNumbersConnecting: false,
				luckyNumbersRetryConnect: false,
				luckyNumbersDisconnectRequested: false,
			}
		case SignalRTypes.LuckyNumbers_Disconnect_Request:
			return {
				...state,
				luckyNumbersDisconnectRequested: true,
			}
		case SignalRTypes.LuckyNumbers_Connect_Retry:
			return {
				...state,
				luckyNumbersConnected: false,
				luckyNumbersConnecting: true,
				luckyNumbersRetryConnect: true,
			}
		case SignalRTypes.Booongo_Connect_Request:
			return {
				...state,
				booongoConnected: false,
				booongoConnecting: true,
				booongoDisconnectRequested: false,
			}

		case SignalRTypes.Booongo_Connect_Success:
			return {
				...state,
				booongoConnected: true,
				booongoConnecting: false,
				booongoRetryConnect: false,
				booongoDisconnectRequested: false,

			}
		case SignalRTypes.Booongo_Disconnect_Success:
		case SignalRTypes.Booongo_Connect_Error:
			return {
				...state,
				booongoConnected: false,
				booongoConnecting: false,
				booongoRetryConnect: false,
				booongoDisconnectRequested: false,
			}

		case SignalRTypes.Booongo_Disconnect_Request:
			return {
				...state,
				booongoDisconnectRequested: true,
			}
		case SignalRTypes.Booongo_Connect_Retry:
			return {
				...state,
				booongoConnected: false,
				booongoConnecting: true,
				booongoRetryConnect: true,
			}
		default:
			return state;

	}
}

export default signalr;